import React, { Fragment } from 'react'
import Navbar2 from '../../components/Navbar2/Navbar2'
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about'
import ProblemSection from '../../components/csp/ProblemSection'
import ApproachSection from '../../components/csp/ApproachSection'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer'
import CtaSection from '../../components/CtaSection/CtaSection'
import { purpose } from '../../content/csp'

const AboutPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={'About'} pagesub={'About'} />
      <About showLink={false} />
      <section className="csp-section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <span className="csp-kicker">What the platform must do</span>
              <h2 className="csp-title">
                Tools for people who will compromise. Guardrails against the
                fight.
              </h2>
              <div className="csp-prose">
                <ul>
                  {purpose.mustDo.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ProblemSection />
      <ApproachSection />
      <CtaSection ctaClass={'wpo-cta-section-s2 pb-0'} />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}
export default AboutPage
